import React, { useState } from "react";
import { Table, Icon, Button, Modal } from "semantic-ui-react";

import EditModal from '../../modals/editModal';

import AddVendorVehicleModal from './add_vehicle_modalnew';
import VehicleDetailModal from "./vendorVehicleDetailsModal";
import {vendor_vehicle} from './vendorConstants'
import { PROMPTS } from "../../../config/const";

const VehicleTable = ({vehicleData, vendorId}) => {

    const [openVehicleAddModal, setOpenVehicleAddModal] = useState(false)

    const vehicleAddModal = () => {
        setOpenVehicleAddModal(true)
    }

    const handleCloseVehicleAddModal = () => {
        setOpenVehicleAddModal(false)
    }
    return (
        <>
            <Table stackable size="small" selectable>
                <Table.Header className="w3-small">
                    <Table.Row>
                        <Table.HeaderCell colSpan="3" className="p-bold-600">
                            {vendor_vehicle?.titles?.vehicle_details||"Vehicle Details"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-600" textAlign="right" >
                            <Button
                                type="button"
                                className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                                add_mode="add"
                                onClick={vehicleAddModal}
                            >
                                <Icon name="plus" /> {vendor_vehicle?.buttons?.new||"New"}
                            </Button>
                        </Table.HeaderCell>
                    </Table.Row>
                    <Table.Row>
                        <Table.HeaderCell className="p-bold-500">
                           {vendor_vehicle?.headers?.vehicle_no||"Vehicle No."}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_vehicle?.headers?.vehicle_type||"Vehicle Type"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_vehicle?.headers?.ownership_type||"Vehicle Ownership Type"}
                        </Table.HeaderCell>
                        <Table.HeaderCell className="p-bold-500">
                            {vendor_vehicle?.headers?.more||"More Details"}
                        </Table.HeaderCell>
                    </Table.Row>            
                </Table.Header>
                <Table.Body>
                    {vehicleData && vehicleData.length > 0 ?    
                        (
                            vehicleData.map((vehicle,vehicleIndex) => (
                                <Table.Row key={vehicleIndex} >
                                    <Table.Cell>
                                        {vehicle.vehicleNumber}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {vehicle.vehicleType}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {vehicle.vehicleOwner}
                                    </Table.Cell>
                                    <Table.Cell>
                                      <VehicleDetailModal data={vehicle} id={vehicle.vehicleId}/>
                                    </Table.Cell>
                                    {/* <Table.Cell colSpan="6" >
                                        <Button onClick={() => userEditModal(vehicle)} basic icon size="mini"><Icon name="eye" color="grey" ></Icon></Button>
                                    </Table.Cell>                               
                                    <EditModal size="tiny" open={openUserEditModal} onClose={handleCloseUserEditModal}>
                                        <Modal.Header>Edit Users</Modal.Header>
                                        <EditVendorUserModal handleCloseUserEditModal={handleCloseUserEditModal} userEditData={userEditData} />
                                    </EditModal>       */}
                                </Table.Row>
                                
                            ))
                        )
                    :
                        (
                            <Table.Row>
                                <Table.Cell colSpan="6">{PROMPTS.NO_RECORDS_FOUND||"No Records Found"}</Table.Cell>
                            </Table.Row>
                        )      
                    }
                </Table.Body>
            </Table>
            <EditModal size="large" open={openVehicleAddModal} onClose={handleCloseVehicleAddModal}>
                <Modal.Header>{vendor_vehicle?.titles?.add_title||"Add Vehicle Details"}</Modal.Header>
                <AddVendorVehicleModal handleCloseUserAddModal={handleCloseVehicleAddModal} vendorId={vendorId} />
            </EditModal>
        </>
    )
}

export default VehicleTable